import {FieldErrors, Controller} from 'react-hook-form'
import DatePicker, {ReactDatePickerProps} from 'react-datepicker'
import es from 'date-fns/locale/es'

type IntrinsicAttributes = any

type InputDatePickerProps = IntrinsicAttributes &
  ReactDatePickerProps<never, undefined> & {
    control: any
    name: string
    errors: FieldErrors
    validateDateRange: (date: Date[] | null) => void
  }
export const InputRangePicker = ({
  control,
  name,
  errors,
  validateDateRange,
  ...props
}: InputDatePickerProps) => {
  return (
    <div className='sdx_form_input sdx-form-date-range-picker'>
      <Controller
        name={name}
        control={control}
        render={({field}) => (
          <DatePicker
            {...props}
            placeholderText='Seleccionar fecha'
            className='form-control sdx-centra-input-form'
            value={field.value}
            onChange={(date) => {
              field.onChange(date)
              validateDateRange(date)
            }}
            locale={es}
          />
        )}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}
